import angular from 'angular'
import btnSingleModalTemplate from './btnModal.html'
import btnMultiModalTemplate from './btnMultiModal.html'

const btnModal = angular
    .module('app.btnModal', [])

export default btnModal.name
/**
 * config : {   必传
 *      title:'删除',
        msg:'确定要删除本条信息吗？',
        btnName:['确定','取消'],  显示按钮的名称的数组，最少传一个
 * }
 * callback 点击第一个按钮执行的回调函数，非必传
*/
btnModal.component('btnSingleModal', {
    template: btnSingleModalTemplate,
    bindings: {
        config: '<',
        callback: '&',
        modalFlag: '=',
    },
    controller: [function () {
        this.$onInit = function () {
            this.flag = false
        }
        this.titleClick = function titleClick() {
            if (this.modalFlag.flag) return
            this.flag = true
            this.modalFlag.flag = true
        }
        this.ok = function ok() {
            this.callback && this.callback()
            this.flag = false
            this.modalFlag.flag = false
        }
        this.cancel = function cancle() {
            this.flag = false
            this.modalFlag.flag = false
        }
    }],
})
btnModal.component('btnMultiModal', {
    template: btnMultiModalTemplate,
    bindings: {
        config: '=',
        callback: '&',
        otherCallback: '&',
        modalFlag: '=',
    },
    controller: [function () {
        this.titleClick = function titleClick() {
            if (this.modalFlag.flag) return
            this.callback && this.callback()
        }
        this.ok = function ok(obj) {
            if (obj.hasCallback) this.otherCallback && this.otherCallback()
            obj.flag = false
            this.modalFlag.flag = false
        }
        this.cancel = function cancel(obj) {
            obj.flag = false
            this.modalFlag.flag = false
        }
    }],
})



// WEBPACK FOOTER //
// ./src/components/btnModal/index.js